import React, { FC, useState } from 'react';
import BlankInput, { BlankInputProps } from './BlankInput';
import { Theme, styled } from '@material-ui/core';

export type ManagedBlankInputProps = Omit<BlankInputProps, 'value' | 'onChange' | 'onBlur'> & {
  value: string;
  onChange: (value: string) => void;
  textColor?: string;
};

const StyledBlankInput = styled(BlankInput)<Theme>(({ theme }) => ({
  width: '100%',
  padding: theme.spacing(1),
}));

const ManagedBlankInput: FC<ManagedBlankInputProps> = ({
  value: initialValue,
  onChange,
  ...other
}) => {
  const [value, setValue] = useState(initialValue);

  return (
    <StyledBlankInput
      value={value}
      onChange={(event: React.FormEvent<HTMLInputElement>) => setValue(event.currentTarget.value)}
      // TODO - take care of duplicate request!!!
      onBlur={() => onChange(value)}
      onReturnKey={() => onChange(value)}
      {...other}
    />
  );
};

export default ManagedBlankInput;
